<template>
  <div class="page-content zizhiAuthZj_jianjie" id="page-content" :style="defaultHeight">
    <div class="startTitle">专家入驻</div>
    <el-row>
      <el-col :offset="4" :span="16">
        <ul class="stepBox">
          <li class="stepText">
            <img alt="" src="../../assets/images/back/step.png">
            <span class="act">实名认证</span>
          </li>
          <li class="stepLine act"></li>
          <li class="stepText">
            <img alt="" src="../../assets/images/back/step.png">
            <span class="act">简介</span>
          </li>
          <li class="stepLine "></li>
          <li class="stepText">
            <img alt="" src="../../assets/images/back/stepno.png">
            <span class="">提交审核</span>
          </li>
        </ul>
      </el-col>
    </el-row>
    <el-row style="margin-top: 30px;">
      <el-col :offset="5" :span="13">
        <!--  基本信息      -->
        <el-form :model="ruleForm" :rules="rules" class="demo-ruleForm" label-width="100px" ref="ruleForm">
          <el-form-item class="txImg" label="头像" prop="txImg">
            <div class="txborBox" style="float: left">
              <el-upload :action="imgAction" :http-request="tx_uploadImg" :multiple="false" name="img" :show-file-list="false" :on-success="handleSuccess" :before-upload="beforeUpload">
                <img :src="ruleForm.txImg" alt="" v-if="ruleForm.txImg">
                <div class="w50box" v-else>
                  <el-button circle icon="el-icon-plus"></el-button>
                  <div>上传图片</div>
                </div>
              </el-upload>
            </div>
            <div class="txText" style="float: left">示例</div>
            <div class="txborBoxshow" style="float: left">
              <img alt="" src="../../assets/images/back/cardimg.jpg">
            </div>

            <input type="hidden" v-model="ruleForm.txImg">
            <div style="clear: both;height: 20px;"></div>
            <span class="txP">
              1、照片清晰，文件小于5M
            </span>
            <span class="txP">
              2、建议着正装职业照，人相居中漏出腰，顶部及两侧有留白
            </span>
            <span class="txP">
              3、建议色调温暖明亮，使用白、灰、银灰色切不能有任务阴影，不建议使用生活照、自拍等
            </span>
          </el-form-item>

          <el-form-item label="手机号码" prop="phone">
            <el-input :disabled="true" style="width: 220px" v-model="ruleForm.phone"></el-input>
            <el-button style="margin-left: 20px;background-color: #596880" type="info" class="dmh-greybtn">更改手机号</el-button>
          </el-form-item>
          <el-form-item label="出生日期" prop="birthday">
            <el-date-picker placeholder="选择日期" type="date" v-model="ruleForm.birthday">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="所在城市">
            <el-select @change="getCityAddress" style="width:140px;margin-right: 25px;" v-model="prov">
              <el-option :key="dict.projectIdentification" :label="dict.label" :value="dict.value" v-for="dict in productList" />
            </el-select>
            <el-select @change="getCountyAddress" style="width:140px;margin-right: 27px;" v-model="city">
              <el-option :key="dict.projectIdentification" :label="dict.label" :value="dict.value" v-for="dict in cityList" />
            </el-select>
            <el-select style="width:140px;" v-if="district" v-model="district">
              <el-option :key="dict.projectIdentification" :label="dict.label" :value="dict.value" v-for="dict in countyList" />
            </el-select>
          </el-form-item>
          <!--          <el-form-item label="地址" prop="address">-->
          <!--            <el-input placeholder="请输入地址" v-model="ruleForm.address"></el-input>-->
          <!--          </el-form-item>-->
          <el-form-item label="工作年限" prop="workyears">
            <el-input placeholder="请输入您的工作年限" v-model="ruleForm.workyears"></el-input>
          </el-form-item>
          <el-form-item label="工作单位" prop="workUnit">
            <el-input placeholder="请输入您的工作单位" v-model="ruleForm.workUnit"></el-input>
          </el-form-item>
          <el-form-item label="个人简介" prop="personProfile">
            <el-input :autosize="{ minRows: 5, maxRows: 1000}" placeholder="请输入，文字内容10-1000字" type="textarea" v-model="ruleForm.personProfile"></el-input>
          </el-form-item>
          <el-form-item label="擅长" prop="begoodat">
            <el-input :autosize="{ minRows: 5, maxRows: 1000}" placeholder="请输入，文字内容10-1000字" type="textarea" v-model="ruleForm.begoodat"></el-input>
          </el-form-item>
          <el-form-item label="擅长领域" prop="begoodatField">
            <el-select placeholder="请选择擅长领域" v-model="ruleForm.begoodatField">
              <el-option :key="item.id" :label="item.tradeCategory" :value="item.id" v-for="item in industryList_2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="微信号" prop="wechatNumber">
            <el-input placeholder="请输入您的微信号码" v-model="ruleForm.wechatNumber"></el-input>
          </el-form-item>
          <el-form-item label="资质证书" required>
            <input type="hidden" v-model="ruleForm.credentials">
            <template v-for="(item,index) in credentials">
              <div :class="index>=1?'zizhiMarT':''" :key="index">
                <el-select placeholder="请选择所属行业" style="width: 65%" v-model="credentials[index]" @change="monSelect(index)">
                  <el-option :key="item.id" :label="item.tradeCategory" :value="item.id" v-for="item in industryList_1"></el-option>
                </el-select>
                <el-button @click="add_credentials()" style="margin-left: 20px;" type="info" class="dmh-greybtn">添加证书类型</el-button>
                <div>
                  <span class="item-zzype" v-if="credentialsList[index].type">{{zizhiTypeObj[credentialsList[index]["type"]]}}</span>
                  <div style="height: 10px"></div>
                  <div class="borBox">
                    <div class="item-img" :style="credentialsList[index].img.length==1?'width:482px;height:233px;':''" v-if="credentialsList[index].img.length!=0" v-for="(childItem,childIndex) in credentialsList[index].img" :key="childItem">
                      <img :src="childItem">
                      <div class="delbtn" @click="delImg(index,childIndex)">x</div>
                    </div>
                    <el-upload v-if="credentialsList[index].img.length<2" :action="imgAction" :http-request="uploadImg" :multiple="false" name="img" :show-file-list="false" :on-success="handleSuccess" :before-upload="beforeUpload" :on-change="(file,fileList)=>{handleChange(file,fileList,index)}" class="upload-demo w100">
                      <div class="w100box">
                        <el-button circle icon="el-icon-plus"></el-button>
                        <div>上传图片</div>
                        <div class="el-upload__tip" style="width: 100%;line-height: 20px;">
                          请使用jpg格式照片，大小不超过5M，无遮挡，无水印；轮廓，文字清晰
                        </div>
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>
            </template>

          </el-form-item>

          <el-form-item>
            <el-button @click="submitForm('ruleForm')" class="btn-submit dmh-colbtn" type="success">提交</el-button>
          </el-form-item>
        </el-form>
        <!--  基本信息      -->

      </el-col>
    </el-row>
  </div>
</template>


<script>
import '@/assets/css/backcommon.css'
import {
  getProductAddress,
  getCityAddress,
  professionalSaveProfessional,
  mechanismGetIndustryList,
  professionalSettleIn,
  uploadImg
} from '@/api/myInfo'
import baseAPI from "@/api/baseAPI";
import Cookies from 'js-cookie'
import { Notification } from 'element-ui'

export default {
  name: "zizhiAuthZj_jianjie",
  data () {
    var ths = this;
    return {
      defaultHeight: {
        height: ""
      },
      //图片列表（用于在上传组件中回显图片）
      fileList: [],
      // 图片上传地址
      imgAction: null,
      //审核失败  修改
      isModifyData: false,
      industryList_2: "",
      industryList_1: "",
      zizhicertObj: {},
      // 省份
      productList: null,
      // 市份
      cityList: null,
      // 区县
      countyList: null,
      prov: '请选择',
      city: '请选择',
      district: '请选择',
      cityArr: [],
      districtArr: [],
      credentials: [""],
      credentialsList: [
        { type: "", img: [] }
      ],
      credentActIndex: -1,
      zizhiTypeObj: {},
      ruleForm: {
        txImg: 'https://dss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=1323060543,1759230141&fm=26&gp=0.jpg',
        phone: "",
        birthday: "2020-12-09",
        // address: "",
        workyears: "",
        workUnit: "",
        personProfile: "",
        begoodat: "",
        wechatNumber: "",
        // zsType:"",
        credentials: ""
      },
      rules: {
        txImg: [
          { required: true, message: '请上传头像', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        // address: [
        //     {required: true, message: '请输入地址', trigger: 'blur'},
        // ],
        workyears: [
          { required: true, message: '请输入您的工作年限', trigger: 'blur' },
        ],
        workUnit: [
          // { required: true, message: '请输入您的工作单位', trigger: 'blur' },
        ],
        birthday: [
          { required: true, message: '请选择出生日期', trigger: 'change' }
        ],
        credentials: [
          // { required: true, message: '请选择资质证书', trigger: 'change' }
        ],
        personProfile: [
          // { required: true, message: '请输入，文字内容10-1000字', trigger: 'blur' },
        ],
        begoodat: [
          // { required: true, message: '请输入，文字内容10-1000字', trigger: 'blur' },
        ],
        begoodatField: [
          // { required: true, message: '请选择擅长领域', trigger: 'change' }
        ],
        wechatNumber: [
          { required: true, message: '请输入您的微信号码', trigger: 'blur' }
        ],
        zsType: [
          // { required: true, message: '请选择上传图片', trigger: 'blur' }
        ]
      }
    }
  },
  components: {},
  beforeMount () {
    var isModifyData = this.$router.currentRoute.query.isModifyData;
    console.log(isModifyData);
    if (isModifyData == undefined) {
      this.isModifyData = "false";
    } else {
      this.isModifyData = "true";
    }
    console.log(this.$store.getters.info.phone);
    this.ruleForm.phone = this.$store.getters.info.phone;
    this.userId = this.$store.state.user.userId;
    if (this.userId === "") {
      this.userId = JSON.parse(Cookies.get("userInfo"))["userId"];
    }

    this.getImgAction()
  },
  mounted () {

    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    window.addEventListener("resize", this.getHeight);
    this.getHeight();

    this.getProductAddress();//所在城市
    this.mechanismGetIndustryList();//专业人员擅长领域

    this.professionalSettleIn();

  },
  watch: {},
  methods: {
    //定义方法，获取高度减去头尾
    getHeight () {
      this.defaultHeight.height = document.getElementById("page-content").innerHeight - 105 + "px";
    },
    message (text) {
      this.$message({
        message: text,
        type: 'warning'
      });
    },
    setData (ths, data) {
      ths.ruleForm.phone = data.userPhone;
      // this.ruleForm.birthday=data.birthday;
      ths.ruleForm.txImg = data.headImg;
      ths.prov = data.projectSecverProvince;
      getCityAddress({ "cityName": data.projectSecverCity, "cityType": 2 }).then(response => {
        this.cityList = response.data.data;
        ths.city = data.projectSecverCity;
        getCityAddress({ "cityName": data.projectSecverCity, "cityType": 3 }).then(response => {
          this.countyList = response.data.data;
          ths.district = data.projectSecverCounty;
        });
      });

      ths.district = data.projectSecverCounty;
      var credentialsList = JSON.parse(data.qualifications);
      var qualifications = JSON.parse(data.qualifications);
      ths.credentials = [];
      for (var i = 0; i < qualifications.length; i++) {
        var item = qualifications[i];
        console.log(item);
        ths.credentials.push(item.type);
        credentialsList.type = ths.zizhiTypeObj[item.type]
      }
      ths.credentialsList = credentialsList;
      ths.ruleForm.wechatNumber = data.wechatId;
      ths.ruleForm.workyears = data.workingYears;
      ths.ruleForm.workUnit = data.workingAddress;
      ths.ruleForm.personProfile = data.briefIntroduction;
      ths.ruleForm.begoodat = data.beGoodAt;
      ths.ruleForm.begoodatField = data.areasOfExpertise;
    },
    professionalSettleIn () {
      var ths = this;
      professionalSettleIn(this.userId).then(res => {

        if (parseFloat(res.data.code) === 200) {
          if (res.data.data === "" || res.data.data === undefined || res.data.data === null) {//填写审核信息
            //ths.myInfoQueryRealById();
            //跳过第一步  直接填写第二步  返回啥啊！
            return;
          } else if (parseInt(res.data.data.status) === 0) {//审核中
            ths.$router.replace('/personCenter/zizhiAuth/zj_submitShenhe');
          } else if (parseInt(res.data.data) === 1) {//  审核成功
            //var successData=res.data.data;
            //this.setData(ths,successData);
            ths.$router.replace('/personCenter/zizhiAuth/zj_submitShenhe');
          } else if (parseInt(res.data.data.status) === 2) {//审核失败
            ths.message(res.data.msg);
            if (this.isModifyData === "false") {
              ths.$router.replace('/personCenter/zizhiAuth/zj_submitShenhe');
              return;
            }
            //需要修改true就回显数据
            ths.setData(ths, res.data.data);
          }
        } else {
          this.message(res.data.msg);
        }
      });
    },
    add_credentials () {
      this.credentials.push("");
      this.credentialsList.push({ "type": "", "img": [] })
    },
    monSelect (index) {
      var selval = this.credentials[index];
      this.credentials[index] = selval;
      this.credentialsList[index]["type"] = selval;
    },
    delImg (index, childIndex) {
      this.credentialsList[index]["img"].splice(childIndex, 1)
    },
    handleChange (file, fileList, index) {
      this.credentActIndex = index;

    },
    mechanismGetIndustryList () {
      mechanismGetIndustryList(2).then(res => {
        this.industryList_2 = res.data.data;
      });
      mechanismGetIndustryList(1).then(res => {
        this.industryList_1 = res.data.data;
        res.data.data.forEach(item => {
          this.zizhiTypeObj[item.id] = item.tradeCategory
        })
      });
    },
    // 赋值文件上传路径
    getImgAction () {
      let _this = this;
      // _this.imgAction = process.env.VUE_APP_BASE_API + '/device/product/uploadImg';
      _this.imgAction = baseAPI + '/device/product/uploadImg';
    },
    beforeUpload (file) {
      const isJPG = file.type === 'image/jpeg';
      const isGIF = file.type === 'image/gif';
      const isPNG = file.type === 'image/png';
      const isBMP = file.type === 'image/bmp';
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isGIF && !isPNG && !isBMP) {
        this.$message.error('上传图片必须是JPG/GIF/PNG/BMP 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
    },
    tx_uploadImg (query) {
      //this.credentialsList[this.credentActIndex].img="上传成功后的图片地址"
      let ths = this;
      let param = new FormData();
      param.append('img', query.file);
      uploadImg(param).then(response => {
        console.log(response.data.data);
        if (parseInt(response.data.code) === 200) {
          ths.ruleForm.txImg = response.data.data; //将返回的文件储存路径赋值picture字段
          // this.form.projectContractName = response.fileName;
          Notification({
            title: response.data.msg,
            type: 'success'
          });
        }
      })
    },
    handleSuccess (res, file) {
      this.message({
        type: 'info',
        message: '图片上传成功',
        duration: 6000
      });
      console.log(res, file);
      // this.imageUrl = URL.createObjectURL(file.raw);
    },
    uploadImg (query) {
      // this.credentialsList[index]["type"] = this.zizhiTypeObj[selval];
      // this.credentActIndex = index;
      //this.credentialsList[this.credentActIndex].img="上传成功后的图片地址"
      let ths = this;
      let param = new FormData();
      param.append('img', query.file);
      uploadImg(param).then(response => {
        console.log(response.data.data);
        if (parseInt(response.data.code) === 200) {
          ths.credentialsList[this.credentActIndex]["img"].push(response.data.data); //将返回的文件储存路径赋值picture字段
          // this.form.projectContractName = response.fileName;
          Notification({
            title: response.data.msg,
            type: 'success'
          });
        }
      })
    },
    submitAjax () {
      var credentials = this.credentials;
      var credentialsList = this.credentialsList;
      for (var i = 0; i < credentials.length; i++) {
        credentialsList[i].type = credentials[i];
      }
      var data = {
        userPhone: this.ruleForm.phone,
        birthday: this.ruleForm.birthday,
        headImg: this.ruleForm.txImg,
        projectSecverProvince: this.prov,
        projectSecverCity: this.city,
        projectSecverCounty: this.district,
        qualifications: JSON.stringify(credentialsList),
        wechatId: this.ruleForm.wechatNumber,
        workingYears: this.ruleForm.workyears,
        //address: this.ruleForm.address,
        workingAddress: this.ruleForm.workUnit,
        briefIntroduction: this.ruleForm.personProfile,
        beGoodAt: this.ruleForm.begoodat,
        areasOfExpertise: this.ruleForm.begoodatField,
        //qualifications:JSON.stringify(this.ruleForm.credentials)
      };
      var ths = this;
      professionalSaveProfessional(data).then(res => {
        if (parseFloat(res.data.code) === 200) {
          ths.message("提交成功");
          ths.$router.push("/personCenter/zizhiAuth/zj_submitShenhe");
          return;
        } else {
          ths.message(res.data.msg);
        }
      })
    },
    submitForm (formName) {
      /* var credentials=this.credentials;
       var credentialsList=this.credentialsList;
       for(var i=0;i<credentials.length;i++){
           credentialsList[i].type=credentials[i];
       }
       console.log(credentialsList);
       return;*/
      var ths = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          ths.submitAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 获取省份
    getProductAddress () {
      getProductAddress().then(response => {
        this.productList = response.data.data;
      });
    },
    // 获取市
    getCityAddress (value) {
      console.log(value)
      var param = { "cityName": value, "cityType": 2 };
      getCityAddress(param).then(response => {
        this.cityList = response.data.data;
      });
    },
    // 获取区县
    getCountyAddress (value) {
      console.log(value)
      var param = { "cityName": value, "cityType": 3 };
      getCityAddress(param).then(response => {
        this.countyList = response.data.data;
      });
    },
  },
}
</script>

<style scoped>
.item-zzype {
  padding: 2px 5px;
  font-weight: 600;
}

.w100.upload-demo {
  /*border: 1px solid #e6dfdf;*/
  /*line-height: 150px;*/
  height: 170px;
  text-align: center;
  /*width: 235px !important;*/
  height: 170px;
  display: inline-block;
  position: relative;
  left: 63px;
}

.w100.upload-demo .el-button {
  border: 2px solid #000000;
}

.w100box {
  /*width: 235px;*/
  line-height: 40px;
  position: relative;
  top: 40px;
}

.zizhiMarT {
  margin-top: 20px;
}

.txborBox {
  text-align: center;
}

.w50box {
  /*width: 235px;*/
  position: relative;
  top: 32px;
}

.w50.upload-demo {
  text-align: center;
  height: 90px;
  display: inline-block;
}

.w50.upload-demo .el-button {
  border: 2px solid #000000;
}

.tipText {
  text-align: center;
  display: block;
  line-height: 40px;
  font-size: 14px;
  color: #999999;
}

.borBox,
.txborBox {
  /*padding: 20px;*/
  border: 1px solid #e6dfdf;
  padding-bottom: 6px;
}

.txborBox {
  width: 140px;
  height: 132px;
}

.txborBox img {
  width: 140px;
  height: 132px;
}

.borBox .item-img {
  cursor: pointer;
  position: relative;
  display: inline-block;
  width: 234px;
  height: 170px;
  /* margin-right: 20px; */
  margin-left: 6px;
  margin-right: 6px;
  margin-top: 5px;
}

.borBox .item-img img {
  width: 100%;
  height: 100%;
}

.borBox .item-img .delbtn {
  display: none;
  position: absolute;
  right: -5px;
  top: -10px;
  width: 20px;
  height: 20px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  border-radius: 50%;
  background-color: #333333;
  color: #ffffff;
}

.borBox .item-img:hover .delbtn {
  display: block;
  cursor: pointer;
}

.borBox .item-img.mr0 {
  margin-right: 0px;
}

.txborBoxshow {
  width: 140px;
  height: 132px;
}

.txText {
  width: 120px;
  text-align: right;
  padding-right: 20px;
  line-height: 132px;
}

.txborBoxshow img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/personCenter/zizhiAuthZj_jianjie.vue